"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
exports.Renderer = void 0;
var React = require("react");
var map_1 = require("../googlemap/map");
var pinToPortals_1 = require("./pinToPortals");
var MarkerStore_1 = require("./MarkerStore");
var useDebounce_1 = require("../common/utils/useDebounce");
exports.Renderer = function (props) {
    if (!global.window)
        return null;
    var mapId = React.useState('asdadsa')[0];
    var mapRef = React.useRef(null);
    var _a = React.useState(null), pins = _a[0], setPins = _a[1];
    var markerStore = React.useState(new MarkerStore_1["default"]())[0];
    var _b = React.useState(null), markerPortals = _b[0], setMarkerPortals = _b[1];
    var debouncedPins = useDebounce_1.useDebounce(pins, 100);
    React.useEffect(function () {
        map_1.createMap(mapId, props.camera, props.minZoom, props.gestureHandling).then(function (newMap) {
            mapRef.current = newMap;
            setPins(props.pins);
            var triggerViewportUpdate = map_1.setMoveHidePinListener(mapRef.current, function (ne, sw, zoom) {
                props.onViewportChanged({ bound: { ne: ne, sw: sw }, zoom: zoom });
            }, props.onCancel);
            triggerViewportUpdate();
            props.onMapReady ? props.onMapReady(newMap) : null;
        });
    }, []);
    React.useEffect(function () {
        if (!mapRef.current)
            return;
        mapRef.current
            .setCenter({ lat: props.camera.center.lat, lng: props.camera.center.lng });
        mapRef.current
            .setZoom(props.camera.zoom);
    }, [props.camera]);
    React.useEffect(function () {
        if (!mapRef.current)
            return;
        setPins(props.pins);
    }, [props.pins]);
    React.useEffect(function () {
        if (debouncedPins === null)
            return;
        if (!mapRef.current)
            return;
        (function () { return __awaiter(void 0, void 0, void 0, function () {
            var portals;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, pinToPortals_1.pinToPortals(mapRef.current, debouncedPins, markerStore, props.pinRenderer)];
                    case 1:
                        portals = _a.sent();
                        setMarkerPortals(portals);
                        return [2 /*return*/];
                }
            });
        }); })();
    }, [debouncedPins]);
    var onZoomIn = function () {
        if (!mapRef.current)
            return;
        mapRef.current.setZoom(mapRef.current.getZoom() + 1);
    };
    var onZoomOut = function () {
        if (!mapRef.current)
            return;
        mapRef.current.setZoom(mapRef.current.getZoom() - 1);
    };
    var renderZoomControl = function () {
        return (React.createElement("div", { className: "c-mapzoom" },
            React.createElement("div", { onClick: onZoomIn, className: "c-mapzoom__btn c-mapzoom__btn--in" }),
            React.createElement("div", { onClick: onZoomOut, className: "c-mapzoom__btn c-mapzoom__btn--out" })));
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { id: mapId, style: { width: '100%', height: '100%' } }, markerPortals),
        props.zoomControl ? renderZoomControl() : null));
};
